import { Vector2 } from "@babylonjs/core/Maths/math.vector";
import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { AbstractInteractorTool } from './tools';
import { WallInteractors } from './interactors';
import { EditWalls } from './../cmd/EditWalls';
import { Util } from '../utils/Util';
import { WallEnding } from '../mdl/Wall';
import { WallSnapping } from './WallSnapping';
import { CoordinatesType } from '@egr/wcf/modules/core/view/View';
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
export class MoveWall extends AbstractInteractorTool {
    constructor(pRoomManager, pStartPos) {
        super(pRoomManager);
        this.mCommand = null;
        this.mLengthFeedback = null;
        this.mStartPos = pStartPos;
    }
    initialize(pMode, pWall) {
        this.mMode = pMode;
        this.mWall = pWall;
        this.mWallDirections = pWall._getConnectedWallDirections();
        this.mCommand = new EditWalls(this.mRoomManager);
        this.mWallSnapping = new WallSnapping(this.mRoomManager);
        //this.mStartPos = new Vector2(0,0);
        this.mWallStart = this.mWall.startPoint.clone();
        this.mWallEnd = this.mWall.endPoint.clone();
        this.mWallLenght = Vector2.Distance(this.mWall.startPoint, this.mWall.endPoint);
        this.mWallDirection = this.mWall.endPoint.subtract(this.mWall.startPoint).normalize();
        this.mSnapStart = false;
        this.mSnapEnd = false;
        this.mSnapCenter = false;
        this.mConnectedWall = null;
        switch (pMode) {
            case WallSnapping.Mode.MoveStart:
                this.mConnectedWall = this.mWall.endCxn;
                break;
            case WallSnapping.Mode.MoveEnd:
                this.mConnectedWall = this.mWall.startCxn;
                break;
            default:
                break;
        }
        this.prepareSnapping();
        if (pMode !== WallSnapping.Mode.MoveWall)
            this.mWall.beginMoving(pMode, this.mStartPos);
        else
            this.mWall.endMoving(pMode);
        this.mRoomManager._removeFloor();
        this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomManager.endInteraction();
        if (this.mWall !== null)
            this.mWall.endMoving(this.mMode); //WallSnapping.Mode.MoveWall
        if (this.mRoomManager.isCollectingWallUpdates)
            this.mRoomManager.reconnectWalls();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        this.mStartPos = Util.to2d(pPos);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    updatePointerPosition(pPos) {
        let tPos = pPos;
        let tnewPos = new Vector3(0, 0, 0);
        this.mCurrentPos = Util.to2d(tPos);
        let tDiffPos = this.mCurrentPos.subtract(this.mStartPos);
        let tinitialCenter = Vector2.Center(this.mWall.startPoint, this.mWall.endPoint);
        let tAngle = null;
        switch (this.mMode) {
            case WallSnapping.Mode.MoveStart:
                tAngle = this.mWall.getAngleBetweenConnectedWall(0, this.mConnectedWall);
                if (tAngle != null) {
                    //console.log('angle: ' + tAngle);
                }
                let tSnapResultS = this.getNewMovePosition(this.mMode, tPos);
                tnewPos = tSnapResultS.vector_Point;
                if (this.mRoomManager.shiftPressed) {
                    let tStart = Util.to3d(this.mWall.endPoint);
                    tnewPos = Util.calcSnapPoint(tStart, tnewPos, 45);
                }
                this.mWall.setStartPoint(Util.to2d(tnewPos));
                break;
            case WallSnapping.Mode.MoveEnd:
                tAngle = this.mWall.getAngleBetweenConnectedWall(1, this.mConnectedWall);
                if (tAngle != null) {
                    //console.log('angle: ' + tAngle);
                }
                let tSnapResultE = this.getNewMovePosition(this.mMode, tPos);
                tnewPos = tSnapResultE.vector_Point;
                if (this.mRoomManager.shiftPressed) {
                    let tStart = Util.to3d(this.mWall.startPoint);
                    tnewPos = Util.calcSnapPoint(tStart, tnewPos, 45);
                }
                this.mWall.setEndPoint(Util.to2d(tnewPos));
                break;
            case WallSnapping.Mode.MoveWall:
                let ttmpPosS = this.mWallStart.add(tDiffPos);
                let ttmpPosE = this.mWallEnd.add(tDiffPos);
                let tCenter = Vector2.Center(ttmpPosS, ttmpPosE);
                this.mSnapCenter = this.mWall.isSnapping;
                //this.mWall.wallSnapped(false);
                let t_SnapResultS = this.getNewMovePosition(WallSnapping.Mode.MoveStart, Util.to3d(ttmpPosS));
                let tDiff_start = Vector2.Distance(Util.to2d(t_SnapResultS.vector_Point), ttmpPosS);
                this.mSnapStart = this.mWall.isSnapping;
                //this.mWall.wallSnapped(false);
                let t_SnapResultE = this.getNewMovePosition(WallSnapping.Mode.MoveEnd, Util.to3d(ttmpPosE));
                let tDiff_end = Vector2.Distance(Util.to2d(t_SnapResultE.vector_Point), ttmpPosE);
                this.mSnapEnd = this.mWall.isSnapping;
                //this.mWall.wallSnapped(false);
                if (this.mWall.startCxn.wall !== null || this.mWall.endCxn.wall !== null) {
                    tCenter = Vector2.Center(this.mWall.startPoint, this.mWall.endPoint);
                    this.mWall.moveWall(Util.to2d(t_SnapResultS.vector_Point).subtract(tCenter));
                }
                else {
                    if (this.mSnapStart && this.mSnapEnd) {
                        if (t_SnapResultS.snap_Type === t_SnapResultE.snap_Type) {
                            if (tDiff_start < tDiff_end) {
                                this.performSnapping(Util.to3d(this.mWall.startPoint));
                                let t_SnapResultS1 = this.getNewMovePosition(WallSnapping.Mode.MoveStart, Util.to3d(ttmpPosS));
                                this.mWall.setWallPosition_start(Util.to2d(t_SnapResultS1.vector_Point), this.mWallLenght, this.mWallDirection);
                            }
                            else {
                                this.performSnapping(Util.to3d(this.mWall.endPoint));
                                let t_SnapResultE1 = this.getNewMovePosition(WallSnapping.Mode.MoveEnd, Util.to3d(ttmpPosE));
                                this.mWall.setWallPosition_end(Util.to2d(t_SnapResultE1.vector_Point), this.mWallLenght, this.mWallDirection);
                            }
                        }
                        else {
                            if (t_SnapResultS.snap_Type === WallSnapping.SnapType.Point) {
                                this.performSnapping(Util.to3d(this.mWall.startPoint));
                                let t_SnapResultS2 = this.getNewMovePosition(WallSnapping.Mode.MoveStart, Util.to3d(ttmpPosS));
                                this.mWall.setWallPosition_start(Util.to2d(t_SnapResultS2.vector_Point), this.mWallLenght, this.mWallDirection);
                            }
                            if (t_SnapResultE.snap_Type === WallSnapping.SnapType.Point) {
                                this.performSnapping(Util.to3d(this.mWall.endPoint));
                                let t_SnapResultE2 = this.getNewMovePosition(WallSnapping.Mode.MoveEnd, Util.to3d(ttmpPosE));
                                this.mWall.setWallPosition_end(Util.to2d(t_SnapResultE2.vector_Point), this.mWallLenght, this.mWallDirection);
                            }
                        }
                    }
                    if (this.mSnapStart && !this.mSnapEnd) {
                        this.performSnapping(Util.to3d(this.mWall.startPoint));
                        this.mWall.setWallPosition_start(Util.to2d(t_SnapResultS.vector_Point), this.mWallLenght, this.mWallDirection);
                    }
                    if (!this.mSnapStart && this.mSnapEnd) {
                        this.performSnapping(Util.to3d(this.mWall.endPoint));
                        this.mWall.setWallPosition_end(Util.to2d(t_SnapResultE.vector_Point), this.mWallLenght, this.mWallDirection);
                    }
                    if (!this.mSnapStart && !this.mSnapEnd && (this.mWall.startCxn.wall !== null || this.mWall.endCxn.wall !== null)) {
                        let tCenter1 = Vector2.Center(this.mWall.startPoint, this.mWall.endPoint);
                        this.mWall.moveWall(this.mCurrentPos.subtract(tCenter1));
                    }
                    if (!this.mSnapStart && !this.mSnapEnd && (this.mWall.startCxn.wall === null && this.mWall.endCxn.wall === null)) {
                        let tCenter2 = Vector2.Center(this.mWall.startPoint, this.mWall.endPoint);
                        this.mWall.moveWall(this.mCurrentPos.subtract(tCenter2));
                    }
                }
                break;
            default:
                break;
        }
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        //setup connection
        if (this.mMode !== WallSnapping.Mode.MoveWall) {
            let tEnding = this.mMode === WallSnapping.Mode.MoveStart ? WallEnding.Start :
                WallEnding.End;
            this.mWall._findNewConnection(tEnding);
        }
        else if (this.mSnapStart && this.mSnapEnd) {
            let tEnding = WallEnding.Start;
            this.mWall._findNewConnection(tEnding);
            tEnding = WallEnding.End;
            this.mWall._findNewConnection(tEnding);
        }
        else if (this.mSnapStart) {
            let tEnding = WallEnding.Start;
            this.mWall._findNewConnection(tEnding);
        }
        else if (this.mSnapEnd) {
            let tEnding = WallEnding.End;
            this.mWall._findNewConnection(tEnding);
        }
        this.mWall._handleFlippedWalls(this.mWallDirections);
        this.mWall._validateConnections(2);
        if (this.mCommand != null) {
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                this.mCommand = null;
                this.stop();
                this.mWall.notifyChange(ElementChangedFlags.PropertyValues);
                for (let tOpening of this.mWall.openings) {
                    if (tOpening != null)
                        tOpening.updateGeometry();
                }
                //this.mRoomManager.findRoom();
            });
        }
    }
    prepareSnapping() {
        super.prepareSnapping();
        //if (this.mMode !== WallSnapping.Mode.MoveWall) {
        this.mWallSnapping.prepareSnapping(this.mMode, this.mWall, this.mMode === WallSnapping.Mode.MoveStart ?
            WallEnding.End : WallEnding.Start);
        //}
    }
    prepareFeedback() {
        super.prepareFeedback();
        this.mLengthFeedback = new WallInteractors(this.mRoomManager, this.mWall);
        this.mLengthFeedback._updateLengthInteractors();
    }
    updateFeedback() {
        super.updateFeedback();
        if (this.mLengthFeedback != null)
            this.mLengthFeedback._updateLengthInteractors();
    }
    clearFeedback() {
        super.clearFeedback();
        this.mWallSnapping.clear();
        if (this.mLengthFeedback != null) {
            this.mLengthFeedback.clear();
            this.mLengthFeedback = null;
        }
    }
    performSnapping(pPos) {
        let tsnapPos = this.mWallSnapping.snap(pPos, this.mView);
        return (tsnapPos);
    }
    // tslint:disable-next-line:cyclomatic-complexity
    getNewMovePosition(pMoveMode, pCurrentPosition) {
        let tRes = {};
        tRes.snap_Type = WallSnapping.SnapType.Nothing;
        tRes.vector_Point = new Vector3(0, 0, 0);
        if (!this.mRoomManager.touchDevice) {
            let tSnapResult = this.performSnapping(pCurrentPosition);
            return (tSnapResult);
        }
        let tview = this.mRoomManager.view;
        if (tview == null)
            return (tRes);
        let ttouchDir = new Vector3(0, 0, 0);
        if (pMoveMode == WallSnapping.Mode.MoveStart)
            ttouchDir = pCurrentPosition.subtract(Util.to3d(this.mWall.endPoint)).normalize();
        if (pMoveMode == WallSnapping.Mode.MoveEnd)
            ttouchDir = pCurrentPosition.subtract(Util.to3d(this.mWall.startPoint)).normalize();
        let tProjPos = tview.projectPoint2(pCurrentPosition, CoordinatesType.Client, null);
        if ((tProjPos != null) && (ttouchDir != null)) {
            let tOffsetPos = pCurrentPosition.add(ttouchDir.scale(0.01));
            let tProjOffsetPos = tview.projectPoint2(tOffsetPos, CoordinatesType.Client, null);
            if (tProjOffsetPos != null) {
                let tDir = tProjOffsetPos.subtract(tProjPos);
                tDir.normalize();
                tDir.scaleInPlace(0); // 80 for offset
                tProjPos.subtractInPlace(tDir);
            }
        }
        if (tProjPos != null) {
            let tpickPos = this.getPlanePickPos2d(tProjPos);
            if (tpickPos != null) {
                let tnewCurrentPos = Util.to2d(tpickPos);
                let tSnapResult = this.performSnapping(Util.to3d(tnewCurrentPos));
                tRes.vector_Point = tSnapResult.vector_Point;
            }
        }
        if (tRes.vector_Point !== null) {
            let tSnapResult = this.performSnapping(tRes.vector_Point);
        }
        return (tRes);
    }
}
